import { FC, useState } from 'react';
import { Image } from 'components/Image';
import { ENV_CONFIG } from 'config/environment';
import { IRecipients } from 'store/recipients/types';
import classNames from 'classnames';
import { sanitizeHtml } from 'helpers/utils';

interface RecipientDetail {
  header_1?: string;
  header_2?: string;
  summary?: string;
  sections?: Array<{ label: string; value: string }>;
}

interface ListRecipientsDetailedProps {
  candidates: IRecipients[];
  recipientDetails: Record<string, RecipientDetail>;
}

export const ListRecipientsDetailed: FC<ListRecipientsDetailedProps> = ({
  candidates,
  recipientDetails,
}) => {
  const [detailVisible, setDetailVisible] = useState<string | null>(null);

  if (!recipientDetails || Object.keys(recipientDetails).length === 0) {
    return <div className="oath-utility gray">No recipient details available</div>;
  }

  const showDetails = (recipientId: string | null) => {
    setDetailVisible(recipientId);
  };

  return (
    <>
      {candidates.map(candidate => {
        const recipientDetail = recipientDetails[candidate.recipient_id];
        if (!recipientDetail) return null;

        return (
          <div key={candidate.recipient_id} className="candidate-full-container bg-white">
            <div
              className={classNames('candidate-container', {
                'detail-expanded': detailVisible === candidate.recipient_id,
              })}
            >
              <div className="candidate-values">
                <Image
                  alt={`Recipient ${candidate.recipient_name}`}
                  src={`${ENV_CONFIG().CLOUD_STORAGE.URL}/recipients/rec_${candidate.misc_ids?.photo_id}.jpg`}
                  fallbackImgType="candidate_square"
                />
                <div className="candidate-name">
                  <div className="inkBlue">{candidate.recipient_name}</div>
                  <div className="gray">{recipientDetail?.header_1}</div>
                  <div className="gray">{recipientDetail?.header_2}</div>
                </div>
              </div>
              <div className="grid">
                <div className="fake-input">
                  <span>$0.00</span>
                </div>
                {detailVisible !== candidate.recipient_id &&
                  (recipientDetail.summary ||
                    (recipientDetail.sections && recipientDetail.sections.length > 0)) && (
                    <button
                      type="button"
                      className="learn-more link-text"
                      onClick={() => showDetails(candidate.recipient_id)}
                    >
                      Learn More
                    </button>
                  )}
              </div>
            </div>
            {detailVisible === candidate.recipient_id && (
              <div className="recipient-detail-expanded">
                <div className="recipient-detail-content">
                  <div className="candidate-details">
                    <span className="summary">{recipientDetail.summary}</span>
                  </div>
                  {recipientDetail.sections?.map((detail, index) => (
                    <div className="candidate-details" key={index}>
                      <span className="label">{detail.label}</span>
                      <span
                        className="description"
                        dangerouslySetInnerHTML={{ __html: sanitizeHtml(detail.value) }}
                      />
                    </div>
                  ))}
                  <button
                    type="button"
                    className="learn-more link-text"
                    onClick={() => showDetails(null)}
                  >
                    Learn Less
                  </button>
                </div>
              </div>
            )}
          </div>
        );
      })}
      <span>...</span>
    </>
  );
};
